import { createContext, useContext, useState } from "react";

export const translations = {
  pl: {
    "nav.tracker": "Tracker Planu Ogólnego",
    "nav.consultations": "Konsultacje",
    "nav.dashboard": "Mój panel",
    "nav.pro": "PRO",
    "nav.login": "Zaloguj",
    "nav.logout": "Wyloguj",
    "nav.register": "Załóż konto",
    "nav.install": "Pobierz aplikację",
    "install.cta": "Pobierz aplikację PlanGmina",
    "install.installed": "Aplikacja zainstalowana",
    "install.installed_hint": "PlanGmina jest na Twoim ekranie głównym.",
    "install.ios_title": "Zainstaluj na iPhone / iPad",
    "install.ios_sub": "Instalacja przez Safari zajmuje 10 sekund.",
    "install.ios_step1": "Dotknij przycisku Udostępnij",
    "install.ios_step2": "Wybierz „Dodaj do ekranu początkowego”",
    "install.card_title": "PlanGmina jako aplikacja",
    "install.card_text": "Dodaj PlanGmina do ekranu głównego telefonu lub tabletu.",
    "install.page_title": "PlanGmina zawsze pod ręką",
    "install.page_sub": "Sprawdzaj działki, monitoruj zmiany planistyczne i wracaj do zapisanych analiz bez szukania strony w przeglądarce.",
    "install.f1": "Wyszukiwanie działek",
    "install.f2": "Plan Ogólny i MPZP",
    "install.f3": "Planning Watch — monitoring zmian",
    "install.f4": "Zapisane działki i raporty",
    "install.f5": "Indeks Gotowości Gmin",
    "install.offline_note": "Aplikacja zapamiętuje swój interfejs, ale aktualne dane urzędowe wymagają połączenia z internetem. Offline nigdy nie pokazujemy danych planistycznych jako aktualnych.",
    "offline.banner": "Połączenie z internetem jest wymagane do pobrania aktualnych danych urzędowych.",
    "hero.badge": "Reforma planistyczna 2026 — studia wygasają 31.08.2026",
    "hero.title": "Co możesz zrobić z tą działką?",
    "hero.subtitle": "PlanGmina to platforma inteligencji planistycznej. Sprawdź status planu ogólnego, MPZP i ryzyko zmian — zanim kupisz, zanim zainwestujesz.",
    "hero.motto": "AI przygotowuje. Człowiek decyduje.",
    "hero.cta": "Sprawdź działkę",
    "search.tab.address": "Adres",
    "search.tab.number": "Numer działki",
    "search.tab.map": "Mapa gmin",
    "search.placeholder.address": "np. ul. Sienkiewicza 12, Piaseczno",
    "search.placeholder.number": "np. 146501_8.0702.182/4 lub 182/4",
    "search.button": "Szukaj",
    "search.cta": "Sprawdź działkę",
    "search.demoMode": "TRYB DEMO (dane przykładowe)",
    "search.instruction.address": "Wpisz adres nieruchomości",
    "search.instruction.number": "Wpisz numer działki (identyfikator TERYT)",
    "search.noData": "Brak danych w źródłach oficjalnych dla tego zapytania. Sprawdź numer działki (identyfikator TERYT) lub dokładny adres.",
    "data.official": "DANE OFICJALNE",
    "data.none": "BRAK DANYCH",
    "real.obreb": "Obręb",
    "real.centroid": "Współrzędne (punkt reprezentatywny)",
    "real.retrieved": "Pobrano",
    "real.watchSoon": "Monitoring Planning Watch i raporty PDF dla działek rzeczywistych — wkrótce.",
    "mpzp.unknown": "Brak danych",
    "watch.demo.alert": "Gmina opublikowała projekt Planu Ogólnego obejmujący działkę 182/4.",
    "watch.demo.deadline": "Konsultacje do: 18.09.2026",
    "watch.demo.action": "Zobacz zmianę →",
    "reports.demo.line1": "Plan Ogólny: brak",
    "reports.demo.line2": "MPZP: obowiązujący",
    "reports.demo.sources": "Źródła: 4 zweryfikowane",
    "reports.demo.updated": "Ostatnia aktualizacja: 28.08.2026",
    "reports.demo.status": "Status: wymaga uwagi",
    "search.mapHint": "Mapa gmin pokazuje statusy planów ogólnych w gminach (tracker) — to nie jest mapa wyboru działek. Działkę wyszukasz w zakładkach Adres lub Numer działki.",
    "search.openMap": "Otwórz mapę gmin",
    "search.noResults": "Brak wyników. Spróbuj: Piaseczno, 182/4, Mokotów, Kórnik…",
    "demo.label": "DANE DEMONSTRACYJNE",
    "how.title": "Jak to działa",
    "how.step1.title": "Znajdź działkę",
    "how.step1.desc": "Wyszukaj adres, numer ewidencyjny działki lub wskaż lokalizację na mapie.",
    "how.step2.title": "Zobacz fakty i interpretację AI",
    "how.step2.desc": "Ściśle rozdzielamy fakty źródłowe od interpretacji AI — nigdy ich nie mieszamy.",
    "how.step3.title": "Generuj raport i monitoruj",
    "how.step3.desc": "Raport planistyczny działki i alerty Planning Watch o każdej zmianie statusu.",
    "tracker.title": "Tracker Planu Ogólnego",
    "tracker.subtitle": "Status przygotowania planów ogólnych — obecnie widok demonstracyjny na 12 wybranych gminach.",
    "tracker.open": "Pełny tracker",
    "status.adopted": "Uchwalony",
    "status.draft": "Projekt",
    "status.consultation": "Konsultacje",
    "status.pending": "Brak / prace",
    "status.unknown": "Brak danych",
    "watch.title": "Planning Watch — monitoring planistyczny",
    "watch.subtitle": "Zapisz działkę, a powiadomimy Cię o uchwaleniu planu ogólnego, zmianach MPZP i nowych konsultacjach.",
    "reports.title": "Raporty due-diligence",
    "reports.subtitle": "Jeden przycisk: identyfikacja działki, statusy planistyczne, ograniczenia, tabela dowodów i źródła.",
    "reports.button": "Generuj raport działki",
    "reports.error.source": "Źródło urzędowe (GUGiK) jest chwilowo niedostępne. Spróbuj ponownie za kilka minut.",
    "reports.error.generic": "Nie udało się wygenerować raportu. Spróbuj ponownie.",
    "reports.error.retry": "Spróbuj ponownie",
    "reports.error.notfound": "Nie znaleziono działki w oficjalnych źródłach. Sprawdź identyfikator i spróbuj ponownie.",
    "prompt.title": "Dołącz do PlanGmina",
    "prompt.default": "Zaloguj się, aby korzystać z tej funkcji.",
    "prompt.save": "Zaloguj się, aby zapisać działkę i otrzymywać powiadomienia o zmianach.",
    "prompt.ai": "Zaloguj się, aby uruchomić analizę AI dokumentu.",
    "prompt.report": "Zaloguj się, aby wygenerować pełny raport PDF z interpretacją AI i tabelą dowodów.",
    "preview.badge": "PODGLĄD",
    "preview.note": "Ograniczony podgląd: fakty źródłowe, statusy planistyczne i oficjalne źródła. Pełny raport zawiera interpretację AI i eksport PDF.",
    "preview.cta": "Zaloguj się i wygeneruj pełny raport",
    "preview.generate": "Generuj pełny raport",
    "audience.title": "Dla kogo",
    "audience.investors.title": "Inwestorzy i deweloperzy",
    "audience.investors.desc": "Oceniaj ryzyko planistyczne portfela działek przed zakupem gruntu.",
    "audience.owners.title": "Właściciele i kupujący",
    "audience.owners.desc": "Sprawdź, co naprawdę można zrobić z działką — zanim podpiszesz umowę.",
    "audience.lawyers.title": "Prawnicy i doradcy",
    "audience.lawyers.desc": "Tabela dowodów z pełną proweniencją: źródło, data, wersja dokumentu.",
    "audience.municipalities.title": "Gminy",
    "audience.municipalities.desc": "Uporządkuj komunikację planistyczną i ułatw mieszkańcom dostęp do aktualnych informacji.",
    "audience.agents.title": "Pośrednicy nieruchomości",
    "audience.agents.desc": "Daj klientom wiarygodny status planistyczny działki i gotowy raport przed transakcją.",
    "faq.title": "Najczęstsze pytania",
    "cta.band.title": "Zanim kupisz — sprawdź status planistyczny działki.",
    "cta.check": "Sprawdź działkę",
    "cta.report": "Wygeneruj raport",
    "faq.q1": "Czy PlanGmina wydaje decyzje lub opinie prawne?",
    "faq.a1": "Nie. PlanGmina nie jest organem administracji publicznej i nie wydaje decyzji administracyjnych ani opinii prawnych. Dostarczamy uporządkowane fakty, interpretację AI i narzędzia do weryfikacji przez profesjonalistę.",
    "faq.q2": "Czym jest plan ogólny gminy?",
    "faq.a2": "Nowy, cyfrowy akt prawa miejscowego wprowadzony reformą planistyczną, zastępujący znaczną część funkcji studium uwarunkowań. Stare studia zachowują skuteczność do 31 sierpnia 2026 r.",
    "faq.q3": "Skąd pochodzą dane?",
    "faq.a3": "Z oficjalnych źródeł publicznych: GUGiK (ULDK), Geoportal/ISOK (mapy zagrożenia powodziowego MZP/MRP, podział hydrograficzny MPHP), IMGW-PIB, Rejestr Urbanistyczny, NID i MIDAS — każdy fakt ma proweniencję (źródło, data pobrania, metoda). Tracker Planu Ogólnego działa obecnie na wyraźnie oznaczonych danych demonstracyjnych (12 gmin).",
    "faq.q4": "Co oznacza „Wymaga weryfikacji”?",
    "faq.a4": "Oznaczenie informacji niepewnych lub pochodzących z ekstrakcji AI. Takie pola musi potwierdzić człowiek — urbanista, prawnik lub architekt.",
    "disclaimer.title": "Zastrzeżenie",
    "disclaimer.text": "PlanGmina nie jest organem administracji publicznej i nie wydaje decyzji administracyjnych ani opinii prawnych. Serwis ma charakter informacyjny. AI przygotowuje. Człowiek decyduje.",
    "footer.tagline": "Sprawdź zanim kupisz. Sprawdź zanim zainwestujesz.",
    "parcel.overview": "Identyfikacja działki",
    "parcel.status.title": "Status planistyczny",
    "parcel.planOgolny": "Plan ogólny gminy",
    "parcel.mpzp": "MPZP",
    "parcel.proceedings": "Postępowania",
    "parcel.consultation": "Konsultacje",
    "parcel.certainty": "Pewność zabudowy",
    "parcel.risk": "Ryzyko zmiany planu",
    "parcel.zone": "Strefa / przeznaczenie",
    "parcel.save": "Zapisz do obserwowanych",
    "parcel.saved": "Zapisano",
    "parcel.loginToSave": "Zaloguj się, aby zapisać działkę",
    "parcel.documents": "Dokumenty źródłowe",
    "parcel.consultations": "Konsultacje w gminie",
    "parcel.area": "Powierzchnia",
    "parcel.back": "Wszystkie wyniki",
    "evidence.facts": "1. Fakty źródłowe",
    "evidence.ai": "2. Interpretacja AI",
    "evidence.noai.title": "2. Warstwa interpretacyjna",
    "evidence.human": "3. Weryfikacja człowieka",
    "evidence.human.pending": "Ten raport nie został jeszcze zweryfikowany przez profesjonalistę.",
    "evidence.human.cta": "Zleć weryfikację urbaniście / prawnikowi",
    "flood.title": "Ryzyko powodziowe",
    "hydro.title": "Wody i zagrożenia hydrologiczne",
    "hydro.exposure": "Zagrożenie hydrologiczne",
    "hydro.affected_area": "Obszar zagrożenia",
    "hydro.affected_pct": "Część działki",
    "hydro.scenario": "Prawdopodobieństwo / kategoria",
    "hydro.nearest_water": "Najbliższy ciek / zbiornik",
    "hydro.crosses": "ciek przecina działkę",
    "hydro.catchment": "Zlewnia",
    "hydro.station": "Najbliższa stacja hydrologiczna",
    "hydro.context_note": "Dane stacji mają charakter kontekstowy.",
    "hydro.warnings": "Aktywne ostrzeżenia hydrologiczne IMGW (zasięg regionalny)",
    "hydro.details.show": "Pokaż szczegóły",
    "hydro.details.hide": "Ukryj szczegóły",
    "hydro.unavailable": "Nie można obecnie potwierdzić danych z tego źródła.",
    "hydro.loading": "Analizuję dane hydrologiczne…",
    "hydro.why": "Dlaczego:",
    "hydro.evidence.official": "DANE OFICJALNE",
    "hydro.evidence.derived": "ANALIZA PLANGMINA",
    "hydro.sources_unavailable": "Źródła czasowo niedostępne",
    "hydro.evidence.contextual": "DANE KONTEKSTOWE",
    "flood.locked.note": "Szczegóły stref, źródło danych i data pobrania dostępne są w pełnym raporcie.",
    "flood.zones.hazard": "Obszary zagrożenia powodziowego (MZP)",
    "flood.zones.risk": "Obszary ryzyka powodziowego (MRP)",
    "flood.method": "Metoda",
    "ru.title": "Rejestr aktów planistycznych",
    "ru.locked.note": "Wykaz aktów ze statusami prawnymi i linkami do rejestru — w pełnym raporcie.",
    "ru.col.act": "Akt",
    "ru.col.type": "Typ",
    "ru.col.status": "Status prawny",
    "ru.col.valid_from": "Obowiązuje od",
    "ru.more": "Kolejne akty w rejestrze",
    "heritage.title": "Dziedzictwo i ochrona konserwatorska",
    "heritage.locked.note": "Wykaz obiektów z relacją do działki, odległościami i źródłami — w pełnym raporcie.",
    "heritage.col.object": "Obiekt",
    "heritage.col.register": "Rejestr",
    "heritage.col.rel": "Relacja",
    "heritage.col.dist": "Odległość",
    "heritage.col.docs": "Dokumenty wpisu",
    "heritage.rel.intersects": "NA DZIAŁCE",
    "heritage.rel.nearby": "W POBLIŻU",
    "heritage.dist.approx": "ok.",
    "heritage.partial": "Część rejestrów była chwilowo niedostępna — wykaz może być niekompletny.",
    "elevation.title": "Wysokość terenu (NMT)",
    "elevation.locked.note": "Wartość wysokości w punkcie środka działki z układem odniesienia i pełną proweniencją — w pełnym raporcie.",
    "elevation.value": "Wysokość (środek działki)",
    "elevation.datum": "Układ wysokościowy",
    "terrain.title": "Ukształtowanie terenu i woda",
    "terrain.min": "Wysokość min.",
    "terrain.max": "Wysokość maks.",
    "terrain.mean": "Wysokość średnia",
    "terrain.range": "Rozpiętość wysokości",
    "terrain.slope": "Spadek reprezentatywny",
    "terrain.aspect": "Dominująca ekspozycja",
    "terrain.rel50": "Względem otoczenia 50 m",
    "terrain.rel100": "Względem otoczenia 100 m",
    "terrain.rel250": "Względem otoczenia 250 m",
    "terrain.ponding": "Obniżenia terenowe",
    "terrain.edges": "Dopływ / odpływ (model)",
    "terrain.catchment": "Lokalny zlew modelowy",
    "terrain.zones": "Strefa najniższa / najwyższa",
    "soils.title": "Gleby (mapa glebowo-rolnicza)",
    "soils.locked.note": "Wykaz konturów glebowych z klasyfikacją, datami wersji i proweniencją — w pełnym raporcie.",
    "soils.col.complex": "Kompleks / użytek",
    "soils.col.type": "Typ/podtyp gleby",
    "soils.col.substrate": "Podłoże",
    "soils.col.version": "Wersja danych",
    "soils.col.source": "Źródło",
    "nav.workspace": "Portfele i obszar roboczy",
    "dash.workspace.title": "Portfele i obszar roboczy",
    "dash.workspace.desc": "Zarządzaj portfelami działek, eksportami PDF i raportami due diligence.",
    "dash.workspace.cta": "Otwórz",
    "ws.title": "Obszar roboczy zespołu",
    "ws.no_org": "Utwórz organizację, aby zarządzać portfelami działek zespołowo.",
    "ws.org_name": "Nazwa organizacji",
    "ws.create": "Utwórz",
    "ws.portfolios": "Portfele / projekty",
    "ws.no_portfolios": "Brak portfeli — utwórz pierwszy poniżej.",
    "ws.create_portfolio": "Nowy portfel",
    "ws.pf_name": "Nazwa portfela",
    "ws.pf_client": "Klient / referencja (opcjonalnie)",
    "ws.pf_desc": "Opis (opcjonalnie)",
    "ws.client_ref": "Klient/ref.",
    "ws.parcels_count": "Działki",
    "ws.alerts_new": "Nowe alerty",
    "ws.members": "Zespół",
    "ws.member_email": "E-mail użytkownika",
    "ws.role": "Rola",
    "ws.remove": "Usuń",
    "ws.add": "Dodaj",
    "ws.back": "Obszar roboczy",
    "ws.error": "Operacja nie powiodła się",
    "ws.kpi.total": "Działki",
    "ws.kpi.action": "Wymagają działania",
    "ws.kpi.changes": "Wykryte zmiany",
    "ws.kpi.unavailable": "Źródła niedostępne",
    "ws.kpi.review": "Do przeglądu",
    "ws.kpi.reports": "Raporty",
    "ws.attention": "Kolejka uwagi — nieprzejrzane alerty",
    "ws.no_alerts": "Brak nieprzejrzanych alertów.",
    "ws.mark_reviewed": "Oznacz jako przejrzane",
    "ws.parcels": "Działki w portfelu",
    "ws.parcel_id": "Identyfikator działki (TERYT)",
    "ws.table.parcel": "Działka",
    "ws.table.label": "Etykieta",
    "ws.table.category": "Kategoria",
    "ws.table.checked": "Sprawdzono",
    "ws.archive": "Archiwizuj",
    "ws.restore": "Przywróć",
    "ws.archived": "archiwum",
    "ws.import_title": "Import zbiorczy (CSV)",
    "ws.import_hint": "Kolumny: parcel_id; adres (gdy brak id); etykieta. Walidacja przed zapisem, duplikaty i nierozstrzygnięte wiersze są raportowane — nic nie jest po cichu odrzucane.",
    "ws.import_run": "Importuj",
    "ws.import_added": "Dodano",
    "ws.import_dup": "Duplikaty",
    "ws.import_unresolved": "Nierozstrzygnięte",
    "ws.notes": "Notatki zespołu",
    "ws.no_notes": "Brak notatek.",
    "ws.note_placeholder": "Dodaj notatkę dla zespołu…",
    "ws.reports": "Historia raportów",
    "ws.no_reports": "Brak raportów dla tego portfela.",
    "ws.report_version": "Wersja",
    "ws.export": "Eksportuj pakiet (ZIP)",
    "ws.cat.ACTION_REQUIRED": "WYMAGA DZIAŁANIA",
    "ws.cat.SOURCE_UNAVAILABLE": "ŹRÓDŁO NIEDOSTĘPNE",
    "ws.cat.REVIEW": "DO PRZEGLĄDU",
    "ws.cat.CHANGE_DETECTED": "WYKRYTO ZMIANĘ",
    "ws.cat.NO_NEW_CHANGE": "BEZ NOWYCH ZMIAN",
    "ws.changes.title": "Zmiany od ostatniego przeglądu",
    "ws.changes.changes": "zmian",
    "ws.changes.none": "Brak zmian od ostatniego przeglądu.",
    "ws.changes.baseline": "Ostatni przegląd / punkt odniesienia",
    "ws.changes.source_issues": "problemów ze źródłami",
    "ws.changes.review_needed": "do przeglądu",
    "ws.changes.new_reports": "nowych raportów",
    "ws.changes.quiet": "bez zmian",
    "ws.mark_all_reviewed": "Oznacz jako przejrzane",
    "ws.digest.settings": "Digest e-mail",
    "ws.digest.enabled": "Włączony",
    "ws.digest.daily": "codziennie",
    "ws.digest.weekly": "co tydzień (pon.)",
    "ws.digest.save": "Zapisz",
    "ws.digest.last": "Ostatni digest",
    "ws.digest.preview": "Podgląd",
    "ws.digest.send": "Wyślij teraz",
    "ws.ai.title": "Podsumowanie AI",
    "ws.ai.generate": "Generuj podsumowanie AI",
    "ws.ai.cached": "zapisana wersja (bez nowego wywołania AI)",
    "ws.ai.current": "aktualne",
    "ws.ai.stale": "nieaktualne — treść zmieniła się od wygenerowania",
    "ws.ai.what_changed": "Co się zmieniło",
    "ws.ai.attention": "Wymaga uwagi",
    "ws.ai.can_wait": "Może poczekać",
    "ws.ai.confidence": "Problemy ze źródłami a wiarygodność",
    "ws.ai.insufficient": "Za mało dowodów do rzetelnego podsumowania — AI nie inferuje.",
    "ws.ai.empty": "Brak wniosków w tej sekcji.",
    "ws.ai.dropped": "Odrzucono twierdzeń bez pokrycia w dowodach",
    "ws.ai.hash": "hash treści",
    "ws.ai.disclaimer": "Podsumowanie AI wyłącznie na podstawie zapisanych, deterministycznych ustaleń. Nie stanowi opinii prawnej ani oceny możliwości zabudowy. AI przygotowuje. Człowiek decyduje.",
    "ws.pdf.export": "Eksport PDF",
    "ws.pdf.exports": "Eksporty PDF",
    "ws.pdf.version": "wersja raportu",
    "ws.pdf.download": "Pobierz",
    "ws.pdf.none": "Brak eksportów PDF.",
    "ws.pdf.failed": "Eksport PDF nie powiódł się",
    "evidence.ai.note": "Interpretacja wygenerowana przez AI. Nie stanowi opinii prawnej.",
    "mpzp.existing": "Obowiązujący",
    "mpzp.none": "Brak",
    "mpzp.expired_studium": "Studium (do 31.08.2026)",
    "proc.none": "Brak",
    "proc.in_progress": "W toku",
    "cons.none": "Brak",
    "cons.active": "W toku",
    "cons.upcoming": "Zaplanowane",
    "cons.closed": "Zakończone",
    "cert.low": "Niska",
    "cert.medium": "Średnia",
    "cert.high": "Wysoka",
    "risk.low": "Niskie",
    "risk.medium": "Średnie",
    "risk.elevated": "Podwyższone",
    "risk.high": "Wysokie",
    "tracker.stats.total": "Gminy w trackerze",
    "tracker.filter.woj": "Województwo",
    "tracker.filter.status": "Status",
    "tracker.all": "Wszystkie",
    "tracker.deadlines": "Nadchodzące terminy konsultacji",
    "tracker.clickHint": "Kliknij gminę na mapie lub w tabeli",
    "gmina.timeline": "Oś czasu planistyczna",
    "gmina.documents": "Dokumenty gminy",
    "gmina.parcels": "Działki demo w tej gminie",
    "gmina.coverage": "Pokrycie MPZP",
    "cons.title": "Konsultacje społeczne",
    "cons.subtitle": "Terminy składania uwag do projektów planów ogólnych.",
    "cons.deadline": "Termin",
    "cons.start": "Start",
    "dash.title": "Mój panel",
    "dash.saved": "Obserwowane działki",
    "dash.alerts": "Alerty Planning Watch",
    "dash.empty": "Nie obserwujesz jeszcze żadnej działki.",
    "dash.find": "Znajdź działkę",
    "dash.lastChecked": "Sprawdzono",
    "dash.reports": "Moje raporty",
    "pro.title": "Panel profesjonalny",
    "pro.subtitle": "Monitoring portfela działek dla deweloperów, prawników i inwestorów.",
    "pro.table.parcel": "Działka",
    "pro.table.gmina": "Gmina",
    "pro.table.plan": "Plan ogólny",
    "pro.table.mpzp": "MPZP",
    "pro.table.risk": "Ryzyko",
    "pro.table.lastChange": "Ost. zmiana",
    "pro.table.nextDeadline": "Najbliższy termin",
    "pro.export": "Eksport CSV",
    "pro.empty": "Zapisz działki, aby zbudować portfel monitoringu.",
    "auth.login.title": "Zaloguj się",
    "auth.register.title": "Utwórz konto",
    "auth.email": "E-mail",
    "auth.password": "Hasło",
    "auth.name": "Imię i nazwisko",
    "auth.login.submit": "Zaloguj",
    "auth.register.submit": "Zarejestruj",
    "auth.toRegister": "Nie masz konta? Zarejestruj się",
    "auth.toLogin": "Masz konto? Zaloguj się",
    "auth.role": "Rola",
    "report.title": "Raport Planistyczny",
    "report.print": "Drukuj / zapisz PDF",
    "report.identification": "Identyfikacja nieruchomości",
    "report.status": "Status planistyczny",
    "report.evidence": "Tabela dowodów",
    "report.dates": "Ważne terminy",
    "report.documents": "Dokumenty źródłowe",
    "report.generated": "Wygenerowano",
    "report.source": "Źródło",
    "report.effective": "Data wejścia",
    "report.version": "Wersja / sygnatura",
    "report.verification": "Weryfikacja",
    "report.confidence": "Pewność",
    "report.noai": "Brak interpretacji AI — raport oparty wyłącznie na danych źródłowych.",
    "report.provenance": "Źródła oficjalne (proweniencja)",
    "report.openSource": "Otwórz źródło",
    "report.sourceError": "Błąd źródła",
    "search.normalized": "Dopasowano po normalizacji adresu",
    "ws.dd.open": "Raport DD",
    "dd.title": "Raport due diligence",
    "dd.subtitle": "Pakiet dowodowy · dane deterministyczne",
    "dd.parcel": "działka nr",
    "dd.back": "← Powrót do portfela",
    "dd.loading": "Ładowanie raportu…",
    "dd.error": "Nie udało się załadować raportu.",
    "dd.noAccess": "Raport due diligence nie jest dostępny w tym planie.",
    "dd.noReport": "Brak zapisanego raportu dla tej działki w tym portfelu.",
    "dd.generateDesc": "Wygeneruj raport z oficjalnych źródeł — zostanie zapisany i powiązany z tym portfelem.",
    "dd.generate": "Generuj raport portfelowy",
    "dd.generating": "Generowanie raportu…",
    "dd.pdf": "Pobierz PDF (A4)",
    "dd.pdfWorking": "Generowanie PDF…",
    "dd.pdfFailed": "Nie udało się wygenerować PDF.",
    "dd.exec": "1. Podsumowanie wykonawcze",
    "dd.identity": "2. Identyfikacja działki",
    "dd.planning": "3. Planowanie",
    "dd.flood": "4. Powódź / wody",
    "dd.heritage": "5. Dziedzictwo / konserwacja",
    "dd.elevation": "6. Wysokość / ukształtowanie",
    "dd.terrainWater": "6a. Teren i woda — analiza modelowa (NMT 1 m)",
    "dd.soils": "7. Gleby",
    "dd.gdos": "7b. Ochrona przyrody (CRFOP)",
    "dd.midas": "7c. Górnictwo i złoża (MIDAS)",
    "dd.mphp": "7d. Sieć hydrograficzna (MPHP)",
    "dd.changes": "Zmiany od ostatniego przeglądu",
    "dd.noChanges": "Brak nowych wykrytych zmian od ostatniego przeglądu.",
    "dd.sourceHealth": "Kondycja źródeł i ograniczenia danych",
    "dd.allAvailable": "Wszystkie źródła dostępne.",
    "dd.provenance": "Proweniencja (źródła)",
    "dd.appendix": "Załącznik dowodowy",
    "dd.integrity": "Integralność raportu",
    "dd.sourcesFull": "Pełne adresy usług źródłowych",
    "dd.relationship": "Relacja",
    "dd.unknown": "brak danych",
    "dd.finding.empty": "Brak zapisanego ustalenia w raporcie dla tej kategorii.",
    "dd.finding.unavailable": "ŹRÓDŁO NIEDOSTĘPNE",
    "dd.finding.uncertain": "Wynik wymaga weryfikacji",
    "dd.unavailableNote": "Źródło niedostępne przy ostatnim sprawdzeniu — to NIE jest zmiana danych działki.",
    "dd.refId": "Nr ref.",
    "dd.generatedAt": "Wygenerowano",
    "dd.dataAsOf": "Stan danych źródłowych",
    "dd.reportVersion": "Wersja raportu",
    "dd.identity.number": "Numer działki",
    "dd.identity.gmina": "Gmina",
    "dd.identity.powiat": "Powiat",
    "dd.identity.woj": "Województwo",
    "dd.identity.area": "Powierzchnia",
    "dd.identity.coords": "Współrzędne środka",
    "dd.identity.address": "Adres",
    "dd.planning.pog": "Plan ogólny",
    "dd.planning.mpzpName": "Nazwa MPZP",
    "dd.planning.zone": "Strefa planistyczna",
    "dd.planning.proceedings": "Postępowania",
    "dd.planning.consultations": "Konsultacje",
    "dd.pog.adopted": "uchwalony",
    "dd.pog.draft": "w projekcie",
    "dd.mpzp.existing": "istniejący MPZP",
    "dd.mpzp.unknown": "brak danych o MPZP",
    "dd.evidence.fact": "Ustalenie",
    "dd.evidence.value": "Wartość",
    "dd.evidence.asOf": "Stan na",
    "report.id": "Raport ID",
    "report.sourcesAt": "Stan źródeł",
    "report.hash": "Hash wersji (SHA-256)",
    "nav.index": "Indeks Gotowości",
    "status.gotowa": "GOTOWA",
    "status.w_trakcie": "W TRAKCIE",
    "status.ograniczona": "OGRANICZONA INFORMACJA",
    "status.brak_danych": "BRAK DANYCH",
    "band.gotowa": "GOTOWA",
    "band.w_trakcie": "W TRAKCIE",
    "band.ograniczona": "OGRANICZONA INFORMACJA",
    "band.brak_danych": "BRAK DANYCH",
    "band.nie_wykryto": "NIE WYKRYTO PLANU",
    "band.zrodlo_niedostepne": "ŹRÓDŁO NIEDOSTĘPNE",
    "band.short.gotowa": "Plan ogólny gminy uchwalony",
    "band.short.w_trakcie": "Projekt planu ogólnego wykryty w krajowym rejestrze",
    "band.short.ograniczona": "Brak planu ogólnego w dostępnych źródłach — istnieją dane MPZP",
    "band.short.brak_danych": "Źródła krajowe nie pozwalają wiarygodnie określić statusu",
    "band.short.nie_wykryto": "Nie wykryto planu w dostępnych źródłach krajowych (nie oznacza braku planu)",
    "band.short.zrodlo_niedostepne": "Nie udało się zweryfikować — co najmniej jedno źródło krajowe niedostępne",
    "conv.title": "Chcesz śledzić tę działkę?",
    "conv.text": "Zapisz działkę i otrzymuj informacje o zmianach planistycznych.",
    "conv.save": "Zapisz działkę",
    "conv.resumed": "Wróciłeś do zapisu tej działki — kliknij „Zapisz działkę”, aby dokończyć.",
    "conv.saved_confirm": "Działka została zapisana.",
    "watch.active_text": "Planning Watch jest aktywny — powiadomimy Cię e-mailem o każdej wykrytej zmianie planistycznej.",
    "watch.title": "Monitoruj zmiany dla tej działki",
    "watch.text": "Planning Watch codziennie sprawdza oficjalne źródła i powiadomi Cię e-mailem, gdy wykryje zmianę statusu planistycznego.",
    "watch.cta": "Włącz Planning Watch",
    "watch.active": "Planning Watch aktywny",
    "inst.title": "Analizujesz więcej nieruchomości?",
    "inst.text": "PlanGmina dla deweloperów, samorządów, kancelarii i profesjonalistów rynku nieruchomości.",
    "inst.cta": "Umów prezentację",
    "inst.footer": "Dla profesjonalistów — umów prezentację",
    "inst.success": "Dziękujemy — odezwiemy się w ciągu 2 dni roboczych.",
    "inst.form.title": "Umów prezentację PlanGmina",
    "inst.form.name": "Imię i nazwisko",
    "inst.form.organization": "Organizacja",
    "inst.form.email": "Służbowy adres e-mail",
    "inst.form.role": "Rola / stanowisko",
    "inst.form.orgtype": "Typ organizacji",
    "inst.form.message": "Wiadomość (opcjonalnie)",
    "inst.form.consent": "Wyrażam zgodę na kontakt handlowy Hussar Holdings LLC w sprawie prezentacji PlanGmina.",
    "inst.form.submit": "Wyślij zgłoszenie",
    "inst.form.sending": "Wysyłanie…",
    "inst.org.samorzad": "Samorząd",
    "inst.org.deweloper": "Deweloper",
    "inst.org.kancelaria": "Kancelaria",
    "inst.org.posrednik": "Pośrednik",
    "inst.org.inwestor": "Inwestor",
    "inst.org.urbanista": "Urbanista",
    "inst.org.inne": "Inne",
    "nav.pricing": "Cennik",
    "pricing.title": "Cennik",
    "pricing.subtitle": "Oficjalne dane planistyczne — od darmowego podglądu do monitoringu całego portfela.",
    "pricing.tax_note": "Ceny brutto w PLN. Prezentacja VAT i zasady fakturowania zostaną potwierdzone z doradcą podatkowym przed uruchomieniem płatności.",
    "pricing.test_note": "Płatności działają w TRYBIE TESTOWYM — żadna transakcja nie jest prawdziwa.",
    "pricing.most_popular": "Najczęstszy wybór",
    "pricing.interval.none": "",
    "pricing.interval.month": "/ mies.",
    "pricing.interval.one_time": "jednorazowo",
    "pricing.interval.30_days": "/ 30 dni",
    "pricing.interval.custom": "",
    "pricing.cta.free": "Szukaj działki",
    "pricing.cta.soon": "Wkrótce",
    "pricing.payments_off_note": "Płatności nie są jeszcze aktywne — ceny prezentują plan komercyjny. Żadne środki nie są pobierane.",
    "pricing.cta.report_single": "Kup przy podglądzie raportu",
    "pricing.cta.pro": "Wybierz Pro",
    "pricing.cta.business": "Wybierz Business",
    "pricing.cta.institutional": "Umów prezentację",
    "pricing.cta.enterprise": "Skontaktuj się",
    "pricing.f.free.1": "Wyszukiwanie działek",
    "pricing.f.free.2": "Podstawowy status planistyczny",
    "pricing.f.free.3": "Pełna transparentność źródeł",
    "pricing.f.free.4": "Ograniczony podgląd raportu",
    "pricing.f.report_single.1": "Jeden pełny raport parcel intelligence",
    "pricing.f.report_single.2": "Kompletne dane planistyczne i źródłowe",
    "pricing.f.report_single.3": "PDF do pobrania",
    "pricing.f.report_single.4": "Potwierdzenie transakcji",
    "pricing.f.pro.1": "10 pełnych raportów miesięcznie",
    "pricing.f.pro.2": "Do 10 zapisanych działek",
    "pricing.f.pro.3": "Do 10 działek w Planning Watch",
    "pricing.f.pro.4": "Powiadomienia o zmianach",
    "pricing.f.pro.5": "Historia konta",
    "pricing.f.business.1": "50 raportów miesięcznie",
    "pricing.f.business.2": "50 zapisanych / monitorowanych działek",
    "pricing.f.business.3": "Do 3 użytkowników",
    "pricing.f.business.4": "Panel portfela",
    "pricing.f.business.5": "Eksporty",
    "pricing.f.business.6": "Dane do faktury (NIP)",
    "pricing.f.institutional.1": "Jedna organizacja, onboarding",
    "pricing.f.institutional.2": "Monitoring 25–50+ działek",
    "pricing.f.institutional.3": "Sesja przeglądowa i podsumowanie pilota",
    "pricing.f.institutional.4": "Priorytetowe wsparcie",
    "pricing.f.enterprise.1": "Dostęp API (roadmapa)",
    "pricing.f.enterprise.2": "Analiza masowa działek",
    "pricing.f.enterprise.3": "Integracje niestandardowe",
    "pricing.f.enterprise.4": "SLA i licencjonowanie danych",
    "checkout.title": "Finalizacja zamówienia",
    "checkout.summary": "Podsumowanie",
    "checkout.billing": "Dane do rozliczenia",
    "checkout.item.report": "Pełny raport działki",
    "checkout.name": "Imię i nazwisko / nazwa",
    "checkout.email": "E-mail do potwierdzenia",
    "checkout.b2b": "Kupuję jako firma / organizacja",
    "checkout.company": "Nazwa firmy",
    "checkout.nip": "NIP / VAT ID",
    "checkout.address": "Adres do rozliczenia",
    "checkout.country": "Kraj rozliczenia",
    "checkout.ctype.private": "Osoba prywatna",
    "checkout.ctype.company": "Firma / organizacja",
    "checkout.submit": "Przejdź do płatności",
    "checkout.tax_blocked": "Ta transakcja wymaga potwierdzenia podatkowego przed płatnością.",
    "checkout.net": "Netto",
    "checkout.vat": "VAT",
    "checkout.gross": "Brutto",
    "checkout.vat_status": "Status walidacji VAT",
    "pay.test.title": "Płatność testowa",
    "pay.test.banner": "TRYB TESTOWY — to symulacja płatności. Żadne środki nie są pobierane.",
    "pay.test.success": "Zapłać (TEST)",
    "pay.test.failure": "Symuluj odrzucenie płatności",
    "pay.test.success_msg": "Płatność testowa zakończona sukcesem — dostęp przyznany.",
    "pay.test.failure_msg": "Płatność odrzucona — dostęp NIE został przyznany.",
    "pay.test.back": "Wróć",
    "upgrade.limit.title": "Osiągnięto limit planu",
    "upgrade.limit.count": "Wykorzystanie",
    "upgrade.limit_saved_parcels": "Osiągnięto limit zapisanych działek. Zwiększ go w PlanGmina Pro.",
    "upgrade.report_locked": "Pełny raport wymaga odblokowania.",
    "upgrade.cta.pro": "Włącz monitoring w PlanGmina Pro",
    "upgrade.cta.pricing": "Zobacz cennik",
    "report.upgrade.title": "Pełny raport jest płatny",
    "report.upgrade.text": "Odblokuj kompletny raport z pełną dokumentacją źródłową i hashem dowodowym dla tej działki.",
    "report.upgrade.cta": "Odblokuj pełny raport — 39 zł",
    "report.upgrade.cta_pro": "PlanGmina Pro — 10 raportów/mies.",
    "dash.plan.title": "Mój plan i płatności",
    "dash.plan.current": "Aktualny plan",
    "dash.plan.change": "Zmień plan",
    "dash.plan.reports": "Raporty w tym miesiącu",
    "dash.plan.saved": "Zapisane działki",
    "dash.plan.cancel": "Anuluj subskrypcję",
    "dash.plan.cancel_note": "Dostęp pozostaje aktywny do końca opłaconego okresu",
    "dash.plan.active_until": "Subskrypcja aktywna do",
    "dash.plan.purchases": "Historia płatności",
    "dash.plan.none": "Brak transakcji",
    "index.title": "Indeks Gotowości Gmin",
    "index.subtitle": "Ogólnopolski status reformy planistycznej — wyłącznie dane z oficjalnych rejestrów publicznych, odświeżane codziennie.",
    "index.search": "Szukaj gminy…",
    "index.allBands": "Wszystkie statusy",
    "index.allWoj": "Wszystkie województwa",
    "index.stats.total": "Gmin w indeksie",
    "index.stats.harvested": "Zweryfikowane",
    "index.stats.lastUpdate": "Ostatnia aktualizacja",
    "index.daily": "dane odświeżane codziennie oraz przy wizycie, gdy starsze niż 24 h",
    "index.pending": "oczekuje na weryfikację",
    "index.more": "Pokaż więcej",
    "index.noResults": "Brak wyników dla podanych filtrów.",
    "index.map.hint": "Kliknij punkt, aby otworzyć stronę gminy. Kolor = status gotowości.",
    "index.why": "Dlaczego ten status?",
    "index.retrieved": "Pobrano",
    "index.owner.title": "Co to oznacza dla właściciela działki?",
    "index.owner.gotowa": "Gmina ma uchwalony plan ogólny — po reformie to on jest podstawą wniosków o pozwolenie na budowę. Sprawdź, co plan przewiduje dla Twojej działki.",
    "index.owner.w_trakcie": "Plan ogólny jest w przygotowaniu — to najlepszy moment, by śledzić konsultacje i mieć wpływ na ustalenia. Przejściowo decydujące pozostają MPZP i decyzje WZ.",
    "index.owner.ograniczona": "Krajowe rejestry nie pokazują planu ogólnego dla tej gminy, ale istnieją dane o planach miejscowych (MPZP). Szczegóły stanu prac znajdziesz w BIP gminy.",
    "index.owner.brak_danych": "Krajowe usługi nie pozwalają wiarygodnie określić statusu tej gminy. Brak danych nie oznacza braku planu — sprawdź BIP lub urząd gminy.",
    "index.owner.nie_wykryto": "Krajowe rejestry odpowiedziały poprawnie, ale nie pokazują planu ogólnego ani danych MPZP dla tej gminy. Nie oznacza to braku planu — aktualny stan prac najlepiej sprawdzić w BIP gminy.",
    "index.owner.zrodlo_niedostepne": "Co najmniej jedno krajowe źródło nie odpowiedziało podczas ostatniej weryfikacji, więc statusu nie da się wiarygodnie określić. Weryfikację powtarzamy codziennie — sprawdź też BIP gminy.",
    "index.cta.parcel": "Sprawdź działkę w PlanGmina",
    "index.cta.back": "Wróć do indeksu",
    "index.methodology": "Metodologia: statusy planu ogólnego (uchwalony/projekt) obejmują z definicji całą gminę. Dane MPZP sprawdzane są w kilku punktach próbkujących w obrębie gminy (pokrycie MPZP bywa częściowe) — brak wykrycia nie oznacza braku planu. Szczegóły zawsze weryfikuj w BIP gminy.",
    "ai.analyze": "Analiza AI dokumentu",
    "ai.analyzing": "Analizuję…",
    "ai.extracted": "Wyekstrahowane pola (AI — wymaga weryfikacji)",
    "ai.loginRequired": "Zaloguj się, aby uruchomić analizę AI.",
    "ai.needsVerification": "Wymaga weryfikacji",
    "account.title": "Konto, bezpieczeństwo i prywatność",
    "account.email.unverified": "Adres e-mail nie został jeszcze zweryfikowany — wysłaliśmy link weryfikacyjny na Twoją skrzynkę.",
    "verify.loading": "Weryfikuję adres…",
    "verify.success": "Adres e-mail zweryfikowany.",
    "verify.error": "Link weryfikacyjny jest nieprawidłowy lub wygasł.",
    "reset.title": "Ustaw nowe hasło",
    "reset.submit": "Zmień hasło",
    "reset.success": "Hasło zostało zmienione. Zaloguj się nowym hasłem.",
    "account.email.resend": "Wyślij ponownie",
    "account.mfa.title": "Uwierzytelnianie dwuetapowe (MFA)",
    "account.mfa.required": "Konta administratora MUSZĄ mieć włączone MFA, aby korzystać z funkcji administracyjnych.",
    "account.mfa.start": "Skonfiguruj MFA",
    "account.mfa.secret": "Klucz TOTP (dodaj do aplikacji uwierzytelniającej)",
    "account.mfa.code": "Kod z aplikacji",
    "account.mfa.enable": "Włącz MFA",
    "account.mfa.enabled": "MFA aktywne",
    "account.export": "Eksportuj moje dane (JSON)",
    "account.delete": "Usuń konto",
    "account.delete.confirm": "Usunięcie konta jest trwałe: obserwowane działki, alerty, raporty i przesłane dokumenty zostaną skasowane.",
    "auth.mfa.title": "Weryfikacja dwuetapowa",
    "auth.mfa.submit": "Potwierdź kod",
    "privacy.link": "Prywatność",
    "docs.upload.title": "Analiza własnego dokumentu",
    "docs.upload.hint": "Prześlij PDF lub TXT (maks. 5 MB). Dokument jest traktowany jako niezweryfikowane źródło — ekstrakcja AI zawsze wymaga weryfikacji przez człowieka.",
    "docs.upload.button": "Prześlij i analizuj AI",
    "common.loading": "Ładowanie…",
    "common.close": "Zamknij",
    "common.view": "Zobacz",
    "common.remove": "Usuń",
    "common.gmina": "Gmina",
    "common.powiat": "Powiat",
    "common.woj": "Województwo",
    "common.document": "Dokument",
    "common.status": "Status",
  },
  en: {
    "nav.tracker": "General Plan Tracker",
    "nav.consultations": "Consultations",
    "nav.dashboard": "My dashboard",
    "nav.pro": "PRO",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",
    "nav.register": "Create account",
    "nav.install": "Install app",
    "install.cta": "Install PlanGmina",
    "install.installed": "App installed",
    "install.installed_hint": "PlanGmina is on your home screen.",
    "install.ios_title": "Install on iPhone / iPad",
    "install.ios_sub": "Installing via Safari takes 10 seconds.",
    "install.ios_step1": "Tap the Share button",
    "install.ios_step2": "Choose “Add to Home Screen”",
    "install.card_title": "PlanGmina as an app",
    "install.card_text": "Add PlanGmina to your phone or tablet home screen.",
    "install.page_title": "PlanGmina always at hand",
    "install.page_sub": "Check parcels, monitor planning changes and return to saved analyses without searching for the website in your browser.",
    "install.f1": "Parcel search",
    "install.f2": "General Plan & MPZP status",
    "install.f3": "Planning Watch — change monitoring",
    "install.f4": "Saved parcels & reports",
    "install.f5": "Gmina Readiness Index",
    "install.offline_note": "The app remembers its interface, but current official data requires an internet connection. Offline we never present planning data as current.",
    "offline.banner": "An internet connection is required to fetch current official data.",
    "hero.badge": "2026 planning reform — old studium plans expire 31.08.2026",
    "hero.title": "What can you do with this parcel?",
    "hero.subtitle": "PlanGmina is a planning-intelligence platform. Check general plan status, MPZP coverage and change risk — before you buy, before you invest.",
    "hero.motto": "AI prepares. Human decides.",
    "hero.cta": "Check a parcel",
    "search.tab.address": "Address",
    "search.tab.number": "Parcel number",
    "search.tab.map": "Gmina map",
    "search.placeholder.address": "e.g. ul. Sienkiewicza 12, Piaseczno",
    "search.placeholder.number": "e.g. 146501_8.0702.182/4 or 182/4",
    "search.button": "Search",
    "search.cta": "Check a parcel",
    "search.demoMode": "DEMO MODE (sample data)",
    "search.instruction.address": "Enter the property address",
    "search.instruction.number": "Enter the parcel number (TERYT identifier)",
    "search.noData": "No official data for this query. Check the parcel number (TERYT identifier) or the exact address.",
    "data.official": "OFFICIAL DATA",
    "data.none": "NO DATA",
    "real.obreb": "District (obręb)",
    "real.centroid": "Coordinates (representative point)",
    "real.retrieved": "Retrieved",
    "real.watchSoon": "Planning Watch monitoring and PDF reports for real parcels — coming soon.",
    "mpzp.unknown": "No data",
    "watch.demo.alert": "The gmina published a draft General Plan covering parcel 182/4.",
    "watch.demo.deadline": "Consultations until: 18.09.2026",
    "watch.demo.action": "See the change →",
    "reports.demo.line1": "General plan: none",
    "reports.demo.line2": "MPZP: in force",
    "reports.demo.sources": "Sources: 4 verified",
    "reports.demo.updated": "Last updated: 28.08.2026",
    "reports.demo.status": "Status: needs attention",
    "search.mapHint": "The gmina map shows general-plan statuses per municipality (tracker) — it is not a live parcel-selection map. To find a parcel, use the Address or Parcel number tab.",
    "search.openMap": "Open gmina map",
    "search.noResults": "No results. Try: Piaseczno, 182/4, Mokotów, Kórnik…",
    "demo.label": "DEMO DATA",
    "how.title": "How it works",
    "how.step1.title": "Find a parcel",
    "how.step1.desc": "Search by address, cadastral parcel number, or pick a location on the map.",
    "how.step2.title": "See facts and AI interpretation",
    "how.step2.desc": "We strictly separate source facts from AI interpretation — they are never merged.",
    "how.step3.title": "Generate reports & monitor",
    "how.step3.desc": "Parcel planning reports plus Planning Watch alerts on every status change.",
    "tracker.title": "General Plan Tracker",
    "tracker.subtitle": "General plan readiness — currently a demo view covering 12 sample municipalities.",
    "tracker.open": "Full tracker",
    "status.adopted": "Adopted",
    "status.draft": "Draft",
    "status.consultation": "Consultation",
    "status.pending": "None / in progress",
    "status.unknown": "No data",
    "watch.title": "Planning Watch",
    "watch.subtitle": "Save a parcel and get notified about general plan adoption, MPZP changes and new consultations.",
    "reports.title": "Due-diligence reports",
    "reports.subtitle": "One click: parcel identification, planning statuses, restrictions, evidence table and sources.",
    "reports.button": "Generate parcel report",
    "reports.error.source": "The official source (GUGiK) is temporarily unavailable. Please retry in a few minutes.",
    "reports.error.generic": "Report generation failed. Please try again.",
    "reports.error.retry": "Retry",
    "reports.error.notfound": "Parcel not found in official sources. Check the identifier and try again.",
    "prompt.title": "Join PlanGmina",
    "prompt.default": "Sign in to use this feature.",
    "prompt.save": "Sign in to save this parcel and receive change notifications.",
    "prompt.ai": "Sign in to run AI document analysis.",
    "prompt.report": "Sign in to generate the full PDF report with AI interpretation and evidence table.",
    "preview.badge": "PREVIEW",
    "preview.note": "Limited preview: source facts, planning statuses and official sources. The full report adds AI interpretation and PDF export.",
    "preview.cta": "Sign in to generate the full report",
    "preview.generate": "Generate full report",
    "audience.title": "Who it's for",
    "audience.investors.title": "Investors & developers",
    "audience.investors.desc": "Assess planning risk across a land portfolio before acquisition.",
    "audience.owners.title": "Owners & buyers",
    "audience.owners.desc": "Check what can realistically be done with a parcel — before you sign.",
    "audience.lawyers.title": "Lawyers & advisors",
    "audience.lawyers.desc": "Evidence tables with full provenance: source, date, document version.",
    "audience.municipalities.title": "Municipalities",
    "audience.municipalities.desc": "Organize planning communication and give residents easy access to current planning information.",
    "audience.agents.title": "Real-estate brokers",
    "audience.agents.desc": "Give clients a credible parcel planning status and a ready report before the transaction.",
    "faq.title": "Frequently asked questions",
    "cta.band.title": "Before you buy — check the parcel's planning status.",
    "cta.check": "Check a parcel",
    "cta.report": "Generate a report",
    "faq.q1": "Does PlanGmina issue decisions or legal opinions?",
    "faq.a1": "No. PlanGmina is not a public administration body and does not issue administrative decisions or legal opinions. We provide structured facts, AI interpretation and tools for professional review.",
    "faq.q2": "What is the plan ogólny gminy?",
    "faq.a2": "A new digital act of local law introduced by the planning reform, replacing much of the old studium framework. Old studium plans remain effective only until 31 August 2026.",
    "faq.q3": "Where does the data come from?",
    "faq.a3": "From official public sources: GUGiK (ULDK), Geoportal/ISOK (flood-hazard maps MZP/MRP, hydrographic division MPHP), IMGW-PIB, the Planning Registry (Rejestr Urbanistyczny), NID and MIDAS — every fact carries provenance (source, retrieval date, method). The General Plan Tracker currently runs on clearly labeled demo data (12 municipalities).",
    "faq.q4": "What does “Requires verification” mean?",
    "faq.a4": "It marks uncertain information or AI-extracted fields. A human — urban planner, lawyer or architect — must confirm them.",
    "disclaimer.title": "Disclaimer",
    "disclaimer.text": "PlanGmina is not a public administration body and does not issue administrative decisions or legal opinions. The service is informational only. AI prepares. Human decides.",
    "footer.tagline": "Check before you buy. Check before you invest.",
    "parcel.overview": "Parcel identification",
    "parcel.status.title": "Planning status",
    "parcel.planOgolny": "General plan",
    "parcel.mpzp": "MPZP (local plan)",
    "parcel.proceedings": "Proceedings",
    "parcel.consultation": "Consultations",
    "parcel.certainty": "Development certainty",
    "parcel.risk": "Plan change risk",
    "parcel.zone": "Zone / designation",
    "parcel.save": "Save to watchlist",
    "parcel.saved": "Saved",
    "parcel.loginToSave": "Sign in to save this parcel",
    "parcel.documents": "Source documents",
    "parcel.consultations": "Gmina consultations",
    "parcel.area": "Area",
    "parcel.back": "All results",
    "evidence.facts": "1. Source facts",
    "flood.title": "Flood risk",
    "hydro.title": "Water & hydrological hazards",
    "hydro.exposure": "Hydrological exposure",
    "hydro.affected_area": "Hazard area",
    "hydro.affected_pct": "Share of parcel",
    "hydro.scenario": "Probability / category",
    "hydro.nearest_water": "Nearest watercourse / water body",
    "hydro.crosses": "watercourse crosses the parcel",
    "hydro.catchment": "Catchment",
    "hydro.station": "Nearest hydrological station",
    "hydro.context_note": "Station data is contextual only.",
    "hydro.warnings": "Active IMGW hydrological warnings (regional scope)",
    "hydro.details.show": "Show details",
    "hydro.details.hide": "Hide details",
    "hydro.unavailable": "Data from this source cannot be confirmed right now.",
    "hydro.loading": "Analysing hydrological data…",
    "hydro.why": "Why:",
    "hydro.evidence.official": "OFFICIAL DATA",
    "hydro.sources_unavailable": "Sources temporarily unavailable",
    "hydro.evidence.derived": "PLANGMINA ANALYSIS",
    "hydro.evidence.contextual": "CONTEXTUAL DATA",
    "flood.locked.note": "Zone details, data source and retrieval date are available in the full report.",
    "flood.zones.hazard": "Flood hazard areas (FH map)",
    "flood.zones.risk": "Flood risk areas (FR map)",
    "flood.method": "Method",
    "ru.title": "Planning acts registry",
    "ru.locked.note": "The act listing with legal statuses and registry links — in the full report.",
    "ru.col.act": "Act",
    "ru.col.type": "Type",
    "ru.col.status": "Legal status",
    "ru.col.valid_from": "Valid from",
    "ru.more": "Further acts in the registry",
    "heritage.title": "Heritage & conservation protection",
    "heritage.locked.note": "The object listing with parcel relationships, distances and sources — in the full report.",
    "heritage.col.object": "Object",
    "heritage.col.register": "Register",
    "heritage.col.rel": "Relationship",
    "heritage.col.dist": "Distance",
    "heritage.col.docs": "Register documents",
    "heritage.rel.intersects": "ON PARCEL",
    "heritage.rel.nearby": "NEARBY",
    "heritage.dist.approx": "approx.",
    "heritage.partial": "Some registers were temporarily unavailable — the listing may be incomplete.",
    "elevation.title": "Terrain elevation (DTM)",
    "elevation.locked.note": "The elevation value at the parcel centroid with its vertical datum and full provenance — in the full report.",
    "elevation.value": "Elevation (parcel centroid)",
    "elevation.datum": "Vertical datum",
    "terrain.title": "Terrain & water",
    "terrain.min": "Min elevation",
    "terrain.max": "Max elevation",
    "terrain.mean": "Mean elevation",
    "terrain.range": "Elevation range",
    "terrain.slope": "Representative slope",
    "terrain.aspect": "Dominant aspect",
    "terrain.rel50": "Vs surroundings 50 m",
    "terrain.rel100": "Vs surroundings 100 m",
    "terrain.rel250": "Vs surroundings 250 m",
    "terrain.ponding": "Terrain depressions",
    "terrain.edges": "Inflow / outflow (model)",
    "terrain.catchment": "Local model catchment",
    "terrain.zones": "Lowest / highest zone",
    "soils.title": "Soils (soil-agricultural map)",
    "soils.locked.note": "The soil-contour listing with classification, version dates and provenance — in the full report.",
    "soils.col.complex": "Complex / land use",
    "soils.col.type": "Soil type/subtype",
    "soils.col.substrate": "Substrate",
    "soils.col.version": "Data version",
    "soils.col.source": "Source",
    "nav.workspace": "Portfolios & workspace",
    "dash.workspace.title": "Portfolios & workspace",
    "dash.workspace.desc": "Manage parcel portfolios, PDF exports and due-diligence reports.",
    "dash.workspace.cta": "Open",
    "ws.title": "Team workspace",
    "ws.no_org": "Create an organization to manage parcel portfolios as a team.",
    "ws.org_name": "Organization name",
    "ws.create": "Create",
    "ws.portfolios": "Portfolios / projects",
    "ws.no_portfolios": "No portfolios yet — create the first one below.",
    "ws.create_portfolio": "New portfolio",
    "ws.pf_name": "Portfolio name",
    "ws.pf_client": "Client / reference (optional)",
    "ws.pf_desc": "Description (optional)",
    "ws.client_ref": "Client/ref.",
    "ws.parcels_count": "Parcels",
    "ws.alerts_new": "New alerts",
    "ws.members": "Team",
    "ws.member_email": "User email",
    "ws.role": "Role",
    "ws.remove": "Remove",
    "ws.add": "Add",
    "ws.back": "Workspace",
    "ws.error": "Operation failed",
    "ws.kpi.total": "Parcels",
    "ws.kpi.action": "Action required",
    "ws.kpi.changes": "Changes detected",
    "ws.kpi.unavailable": "Sources unavailable",
    "ws.kpi.review": "Needs review",
    "ws.kpi.reports": "Reports",
    "ws.attention": "Attention queue — unreviewed alerts",
    "ws.no_alerts": "No unreviewed alerts.",
    "ws.mark_reviewed": "Mark reviewed",
    "ws.parcels": "Portfolio parcels",
    "ws.parcel_id": "Parcel identifier (TERYT)",
    "ws.table.parcel": "Parcel",
    "ws.table.label": "Label",
    "ws.table.category": "Category",
    "ws.table.checked": "Checked",
    "ws.archive": "Archive",
    "ws.restore": "Restore",
    "ws.archived": "archived",
    "ws.import_title": "Batch import (CSV)",
    "ws.import_hint": "Columns: parcel_id; address (when no id); label. Validated before commit; duplicates and unresolved rows are reported — nothing is silently discarded.",
    "ws.import_run": "Import",
    "ws.import_added": "Added",
    "ws.import_dup": "Duplicates",
    "ws.import_unresolved": "Unresolved",
    "ws.notes": "Team notes",
    "ws.no_notes": "No notes yet.",
    "ws.note_placeholder": "Add a note for the team…",
    "ws.reports": "Report history",
    "ws.no_reports": "No reports for this portfolio.",
    "ws.report_version": "Version",
    "ws.export": "Export package (ZIP)",
    "ws.cat.ACTION_REQUIRED": "ACTION REQUIRED",
    "ws.cat.SOURCE_UNAVAILABLE": "SOURCE UNAVAILABLE",
    "ws.cat.REVIEW": "NEEDS REVIEW",
    "ws.cat.CHANGE_DETECTED": "CHANGE DETECTED",
    "ws.cat.NO_NEW_CHANGE": "NO NEW CHANGE",
    "ws.changes.title": "Changes since last review",
    "ws.changes.changes": "changes",
    "ws.changes.none": "No changes since your last review.",
    "ws.changes.baseline": "Last review / baseline",
    "ws.changes.source_issues": "source issues",
    "ws.changes.review_needed": "to review",
    "ws.changes.new_reports": "new reports",
    "ws.changes.quiet": "unchanged",
    "ws.mark_all_reviewed": "Mark reviewed",
    "ws.digest.settings": "Email digest",
    "ws.digest.enabled": "Enabled",
    "ws.digest.daily": "daily",
    "ws.digest.weekly": "weekly (Mon)",
    "ws.digest.save": "Save",
    "ws.digest.last": "Last digest",
    "ws.digest.preview": "Preview",
    "ws.digest.send": "Send now",
    "ws.ai.title": "AI summary",
    "ws.ai.generate": "Generate AI summary",
    "ws.ai.cached": "cached version (no new AI call)",
    "ws.ai.current": "current",
    "ws.ai.stale": "stale — content changed since generation",
    "ws.ai.what_changed": "What changed",
    "ws.ai.attention": "Needs attention",
    "ws.ai.can_wait": "Can wait",
    "ws.ai.confidence": "Source issues & confidence",
    "ws.ai.insufficient": "Insufficient evidence for a reliable summary — AI does not infer.",
    "ws.ai.empty": "No items in this section.",
    "ws.ai.dropped": "Statements dropped for lack of evidence refs",
    "ws.ai.hash": "content hash",
    "ws.ai.disclaimer": "AI summary based solely on stored deterministic findings. Not a legal opinion or a buildability assessment. AI prepares. Humans decide.",
    "ws.pdf.export": "PDF export",
    "ws.pdf.exports": "PDF exports",
    "ws.pdf.version": "report version",
    "ws.pdf.download": "Download",
    "ws.pdf.none": "No PDF exports yet.",
    "ws.pdf.failed": "PDF export failed",
    "evidence.ai": "2. AI interpretation",
    "evidence.noai.title": "2. Interpretation layer",
    "evidence.human": "3. Human review",
    "evidence.human.pending": "This report has not yet been reviewed by a professional.",
    "evidence.human.cta": "Request planner / lawyer review",
    "evidence.ai.note": "AI-generated interpretation. Not a legal opinion.",
    "mpzp.existing": "In force",
    "mpzp.none": "None",
    "mpzp.expired_studium": "Studium (until 31.08.2026)",
    "proc.none": "None",
    "proc.in_progress": "In progress",
    "cons.none": "None",
    "cons.active": "Active",
    "cons.upcoming": "Upcoming",
    "cons.closed": "Closed",
    "cert.low": "Low",
    "cert.medium": "Medium",
    "cert.high": "High",
    "risk.low": "Low",
    "risk.medium": "Medium",
    "risk.elevated": "Elevated",
    "risk.high": "High",
    "tracker.stats.total": "Gminas tracked",
    "tracker.filter.woj": "Voivodeship",
    "tracker.filter.status": "Status",
    "tracker.all": "All",
    "tracker.deadlines": "Upcoming consultation deadlines",
    "tracker.clickHint": "Click a gmina on the map or in the table",
    "gmina.timeline": "Planning timeline",
    "gmina.documents": "Gmina documents",
    "gmina.parcels": "Demo parcels in this gmina",
    "gmina.coverage": "MPZP coverage",
    "cons.title": "Public consultations",
    "cons.subtitle": "Deadlines for submitting remarks on draft general plans.",
    "cons.deadline": "Deadline",
    "cons.start": "Start",
    "dash.title": "My dashboard",
    "dash.saved": "Watched parcels",
    "dash.alerts": "Planning Watch alerts",
    "dash.empty": "You are not watching any parcels yet.",
    "dash.find": "Find a parcel",
    "dash.lastChecked": "Checked",
    "dash.reports": "My reports",
    "pro.title": "Professional dashboard",
    "pro.subtitle": "Parcel portfolio monitoring for developers, lawyers and investors.",
    "pro.table.parcel": "Parcel",
    "pro.table.gmina": "Gmina",
    "pro.table.plan": "General plan",
    "pro.table.mpzp": "MPZP",
    "pro.table.risk": "Risk",
    "pro.table.lastChange": "Last change",
    "pro.table.nextDeadline": "Next deadline",
    "pro.export": "Export CSV",
    "pro.empty": "Save parcels to build a monitoring portfolio.",
    "auth.login.title": "Sign in",
    "auth.register.title": "Create account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.login.submit": "Sign in",
    "auth.register.submit": "Register",
    "auth.toRegister": "No account? Register",
    "auth.toLogin": "Have an account? Sign in",
    "auth.role": "Role",
    "report.title": "Planning Report",
    "report.print": "Print / save PDF",
    "report.identification": "Property identification",
    "report.status": "Planning status",
    "report.evidence": "Evidence table",
    "report.dates": "Key dates",
    "report.documents": "Source documents",
    "report.generated": "Generated",
    "report.source": "Source",
    "report.effective": "Effective date",
    "report.version": "Version / ref",
    "report.verification": "Verification",
    "report.confidence": "Confidence",
    "report.noai": "No AI interpretation — this report is based solely on source data.",
    "report.provenance": "Official sources (provenance)",
    "report.openSource": "Open source",
    "search.normalized": "Matched after address normalization",
    "ws.dd.open": "DD report",
    "report.sourceError": "Source error",
    "dd.title": "Due-diligence report",
    "dd.subtitle": "Evidentiary package · deterministic data",
    "dd.parcel": "parcel no.",
    "dd.back": "← Back to portfolio",
    "dd.loading": "Loading report…",
    "dd.error": "Failed to load the report.",
    "dd.noAccess": "The due-diligence report is not available on this plan.",
    "dd.noReport": "No stored report for this parcel in this portfolio.",
    "dd.generateDesc": "Generate a report from official sources — it will be saved and linked to this portfolio.",
    "dd.generate": "Generate portfolio report",
    "dd.generating": "Generating report…",
    "dd.pdf": "Download PDF (A4)",
    "dd.pdfWorking": "Generating PDF…",
    "dd.pdfFailed": "PDF generation failed.",
    "dd.exec": "1. Executive summary",
    "dd.identity": "2. Parcel identity",
    "dd.planning": "3. Planning",
    "dd.flood": "4. Flood / water",
    "dd.heritage": "5. Heritage / conservation",
    "dd.elevation": "6. Elevation / terrain",
    "dd.terrainWater": "6a. Terrain & water — model analysis (DTM 1 m)",
    "dd.soils": "7. Soils",
    "dd.gdos": "7b. Protected areas (CRFOP)",
    "dd.midas": "7c. Mining & deposits (MIDAS)",
    "dd.mphp": "7d. Hydrographic network (MPHP)",
    "dd.changes": "Changes since previous review",
    "dd.noChanges": "No new changes detected since the previous review.",
    "dd.sourceHealth": "Source health and data limitations",
    "dd.allAvailable": "All sources available.",
    "dd.provenance": "Provenance (sources)",
    "dd.appendix": "Evidence appendix",
    "dd.integrity": "Report integrity",
    "dd.sourcesFull": "Full source URLs",
    "dd.relationship": "Relationship",
    "dd.unknown": "no data",
    "dd.finding.empty": "No stored finding in this report for this category.",
    "dd.finding.unavailable": "SOURCE UNAVAILABLE",
    "dd.finding.uncertain": "Result requires verification",
    "dd.unavailableNote": "Source unavailable at last check — this is NOT a change to parcel data.",
    "dd.refId": "Ref no.",
    "dd.generatedAt": "Generated",
    "dd.dataAsOf": "Source data as of",
    "dd.reportVersion": "Report version",
    "dd.identity.number": "Parcel number",
    "dd.identity.gmina": "Municipality",
    "dd.identity.powiat": "County",
    "dd.identity.woj": "Voivodeship",
    "dd.identity.area": "Area",
    "dd.identity.coords": "Centroid coordinates",
    "dd.identity.address": "Address",
    "dd.planning.pog": "General plan",
    "dd.planning.mpzpName": "MPZP name",
    "dd.planning.zone": "Planning zone",
    "dd.planning.proceedings": "Proceedings",
    "dd.planning.consultations": "Consultations",
    "dd.pog.adopted": "adopted",
    "dd.pog.draft": "in draft",
    "dd.mpzp.existing": "existing MPZP",
    "dd.mpzp.unknown": "no MPZP data",
    "dd.evidence.fact": "Finding",
    "dd.evidence.value": "Value",
    "dd.evidence.asOf": "As of",
    "report.id": "Report ID",
    "report.sourcesAt": "Source snapshot",
    "report.hash": "Version hash (SHA-256)",
    "nav.index": "Readiness Index",
    "status.gotowa": "READY",
    "status.w_trakcie": "IN PROGRESS",
    "status.ograniczona": "LIMITED INFORMATION",
    "status.brak_danych": "NO DATA",
    "band.gotowa": "READY",
    "band.w_trakcie": "IN PROGRESS",
    "band.ograniczona": "LIMITED INFORMATION",
    "band.brak_danych": "NO DATA",
    "band.nie_wykryto": "NO PLAN DETECTED",
    "band.zrodlo_niedostepne": "SOURCE UNAVAILABLE",
    "band.short.gotowa": "General municipal plan adopted",
    "band.short.w_trakcie": "Draft general plan detected in the national register",
    "band.short.ograniczona": "No general plan in available sources — local zoning (MPZP) data exists",
    "band.short.brak_danych": "National sources cannot reliably determine the status",
    "band.short.nie_wykryto": "No plan detected in the available national sources (does not mean no plan exists)",
    "band.short.zrodlo_niedostepne": "Could not verify — at least one national source was unavailable",
    "conv.title": "Want to track this parcel?",
    "conv.text": "Save the parcel and receive notifications about planning changes.",
    "conv.save": "Save parcel",
    "conv.resumed": "You returned to save this parcel — click \"Save parcel\" to finish.",
    "conv.saved_confirm": "The parcel has been saved.",
    "watch.active_text": "Planning Watch is active — we will email you whenever a planning change is detected.",
    "watch.title": "Monitor changes for this parcel",
    "watch.text": "Planning Watch checks official sources daily and emails you when it detects a change in planning status.",
    "watch.cta": "Enable Planning Watch",
    "watch.active": "Planning Watch active",
    "inst.title": "Analyzing multiple properties?",
    "inst.text": "PlanGmina for developers, municipalities, law firms and real-estate professionals.",
    "inst.cta": "Book a presentation",
    "inst.footer": "For professionals — book a presentation",
    "inst.success": "Thank you — we will get back to you within 2 business days.",
    "inst.form.title": "Book a PlanGmina presentation",
    "inst.form.name": "Full name",
    "inst.form.organization": "Organization",
    "inst.form.email": "Work email",
    "inst.form.role": "Role / position",
    "inst.form.orgtype": "Organization type",
    "inst.form.message": "Message (optional)",
    "inst.form.consent": "I consent to being contacted by Hussar Holdings LLC regarding a PlanGmina presentation.",
    "inst.form.submit": "Send request",
    "inst.form.sending": "Sending…",
    "inst.org.samorzad": "Municipality",
    "inst.org.deweloper": "Developer",
    "inst.org.kancelaria": "Law firm",
    "inst.org.posrednik": "Agent / broker",
    "inst.org.inwestor": "Investor",
    "inst.org.urbanista": "Urban planner",
    "inst.org.inne": "Other",
    "nav.pricing": "Pricing",
    "pricing.title": "Pricing",
    "pricing.subtitle": "Official planning data — from free preview to full portfolio monitoring.",
    "pricing.tax_note": "Gross prices in PLN. VAT presentation and invoicing rules will be confirmed with a tax adviser before payments go live.",
    "pricing.test_note": "Payments run in TEST MODE — no transaction is real.",
    "pricing.most_popular": "Most popular",
    "pricing.interval.none": "",
    "pricing.interval.month": "/ mo",
    "pricing.interval.one_time": "one-time",
    "pricing.interval.30_days": "/ 30 days",
    "pricing.interval.custom": "",
    "pricing.cta.free": "Search a parcel",
    "pricing.cta.report_single": "Buy at report preview",
    "pricing.cta.pro": "Choose Pro",
    "pricing.cta.business": "Choose Business",
    "pricing.cta.institutional": "Book a presentation",
    "pricing.cta.enterprise": "Contact us",
    "pricing.cta.soon": "Coming soon",
    "pricing.payments_off_note": "Payments are not active yet — prices show the commercial plan. No funds are collected.",
    "pricing.f.free.1": "Parcel search",
    "pricing.f.free.2": "Basic planning status",
    "pricing.f.free.3": "Full source transparency",
    "pricing.f.free.4": "Limited report preview",
    "pricing.f.report_single.1": "One full parcel intelligence report",
    "pricing.f.report_single.2": "Complete planning and source detail",
    "pricing.f.report_single.3": "Downloadable PDF",
    "pricing.f.report_single.4": "Transaction receipt",
    "pricing.f.pro.1": "10 full reports per month",
    "pricing.f.pro.2": "Up to 10 saved parcels",
    "pricing.f.pro.3": "Up to 10 Planning Watch parcels",
    "pricing.f.pro.4": "Change notifications",
    "pricing.f.pro.5": "Account history",
    "pricing.f.business.1": "50 reports per month",
    "pricing.f.business.2": "50 saved / watched parcels",
    "pricing.f.business.3": "Up to 3 users",
    "pricing.f.business.4": "Portfolio dashboard",
    "pricing.f.business.5": "Exports",
    "pricing.f.business.6": "Business billing details (VAT ID)",
    "pricing.f.institutional.1": "One organization, onboarding",
    "pricing.f.institutional.2": "Monitoring of 25–50+ parcels",
    "pricing.f.institutional.3": "Review session and pilot summary",
    "pricing.f.institutional.4": "Priority support",
    "pricing.f.enterprise.1": "API access (roadmap)",
    "pricing.f.enterprise.2": "Bulk parcel analysis",
    "pricing.f.enterprise.3": "Custom integrations",
    "pricing.f.enterprise.4": "SLA and data licensing",
    "checkout.title": "Checkout",
    "checkout.summary": "Order summary",
    "checkout.billing": "Billing details",
    "checkout.item.report": "Full parcel report",
    "checkout.name": "Full name / entity name",
    "checkout.email": "Receipt email",
    "checkout.b2b": "Buying as a company / organization",
    "checkout.company": "Company name",
    "checkout.nip": "VAT ID / NIP",
    "checkout.address": "Billing address",
    "checkout.country": "Billing country",
    "checkout.ctype.private": "Private person",
    "checkout.ctype.company": "Company / organization",
    "checkout.submit": "Proceed to payment",
    "checkout.tax_blocked": "This transaction requires tax confirmation before payment.",
    "checkout.net": "Net",
    "checkout.vat": "VAT",
    "checkout.gross": "Gross",
    "checkout.vat_status": "VAT validation status",
    "pay.test.title": "Test payment",
    "pay.test.banner": "TEST MODE — this is a payment simulation. No funds are charged.",
    "pay.test.success": "Pay (TEST)",
    "pay.test.failure": "Simulate payment failure",
    "pay.test.success_msg": "Test payment succeeded — access granted.",
    "pay.test.failure_msg": "Payment declined — access was NOT granted.",
    "pay.test.back": "Return",
    "upgrade.limit.title": "Plan limit reached",
    "upgrade.limit.count": "Usage",
    "upgrade.limit_saved_parcels": "Saved-parcel limit reached. Raise it with PlanGmina Pro.",
    "upgrade.report_locked": "The full report requires unlocking.",
    "upgrade.cta.pro": "Enable monitoring with PlanGmina Pro",
    "upgrade.cta.pricing": "See pricing",
    "report.upgrade.title": "The full report is paid",
    "report.upgrade.text": "Unlock the complete report with full source documentation and the evidence hash for this parcel.",
    "report.upgrade.cta": "Unlock full report — 39 zł",
    "report.upgrade.cta_pro": "PlanGmina Pro — 10 reports/mo",
    "dash.plan.title": "My plan & payments",
    "dash.plan.current": "Current plan",
    "dash.plan.change": "Change plan",
    "dash.plan.reports": "Reports this month",
    "dash.plan.saved": "Saved parcels",
    "dash.plan.cancel": "Cancel subscription",
    "dash.plan.cancel_note": "Access stays active until the end of the paid period",
    "dash.plan.active_until": "Subscription active until",
    "dash.plan.purchases": "Payment history",
    "dash.plan.none": "No transactions",
    "index.title": "Municipal Readiness Index",
    "index.subtitle": "National planning-reform status of Polish gminas — official public registers only, refreshed daily.",
    "index.search": "Search gminas…",
    "index.allBands": "All statuses",
    "index.allWoj": "All voivodeships",
    "index.stats.total": "Gminas in index",
    "index.stats.harvested": "Verified",
    "index.stats.lastUpdate": "Last update",
    "index.daily": "data refreshed daily and on visit when older than 24 h",
    "index.pending": "pending verification",
    "index.more": "Show more",
    "index.noResults": "No results for the selected filters.",
    "index.map.hint": "Click a dot to open the gmina page. Colour = readiness status.",
    "index.why": "Why this status?",
    "index.retrieved": "Retrieved",
    "index.owner.title": "What does this mean for a landowner?",
    "index.owner.gotowa": "The gmina has an adopted general plan — after the reform it is the basis for building-permit applications. Check what the plan provides for your parcel.",
    "index.owner.w_trakcie": "The general plan is being drafted — the best time to follow consultations and influence the provisions. Local plans (MPZP) and WZ decisions remain decisive in the transition.",
    "index.owner.ograniczona": "National registers show no general plan for this gmina, but local zoning (MPZP) data exists. For the detailed stage of work, see the gmina's BIP.",
    "index.owner.brak_danych": "National services cannot reliably determine this gmina's status. No data does not mean no plan — check the gmina's BIP or office.",
    "index.owner.nie_wykryto": "National registries answered correctly but show no general plan or MPZP data for this gmina. This does not mean no plan exists — check the gmina's BIP for the current stage of work.",
    "index.owner.zrodlo_niedostepne": "At least one national source did not respond during the last check, so the status cannot be reliably determined. We retry daily — also check the gmina's BIP.",
    "index.cta.parcel": "Check a parcel in PlanGmina",
    "index.cta.back": "Back to the index",
    "index.methodology": "Methodology: general-plan statuses (adopted/draft) cover the whole gmina by definition. MPZP data is sampled at several interior points within the gmina (MPZP coverage is often partial) — no detection does not mean no plan exists. Always verify details in the gmina's BIP.",
    "ai.analyze": "AI document analysis",
    "ai.analyzing": "Analyzing…",
    "ai.extracted": "Extracted fields (AI — requires verification)",
    "ai.loginRequired": "Sign in to run AI analysis.",
    "ai.needsVerification": "Requires verification",
    "account.title": "Account, security & privacy",
    "account.email.unverified": "Your email address is not verified yet — we have sent a verification link to your inbox.",
    "verify.loading": "Verifying address…",
    "verify.success": "Email address verified.",
    "verify.error": "The verification link is invalid or expired.",
    "reset.title": "Set a new password",
    "reset.submit": "Change password",
    "reset.success": "Password changed. Sign in with your new password.",
    "account.email.resend": "Resend",
    "account.mfa.title": "Two-factor authentication (MFA)",
    "account.mfa.required": "Admin accounts MUST enable MFA to use administrative functions.",
    "account.mfa.start": "Set up MFA",
    "account.mfa.secret": "TOTP secret (add to your authenticator app)",
    "account.mfa.code": "Authenticator code",
    "account.mfa.enable": "Enable MFA",
    "account.mfa.enabled": "MFA active",
    "account.export": "Export my data (JSON)",
    "account.delete": "Delete account",
    "account.delete.confirm": "Account deletion is permanent: watched parcels, alerts, reports and uploaded documents will be erased.",
    "auth.mfa.title": "Two-factor verification",
    "auth.mfa.submit": "Confirm code",
    "privacy.link": "Privacy",
    "docs.upload.title": "Analyze your own document",
    "docs.upload.hint": "Upload a PDF or TXT (max 5 MB). The document is treated as an unverified source — AI extraction always requires human review.",
    "docs.upload.button": "Upload & analyze with AI",
    "common.loading": "Loading…",
    "common.close": "Close",
    "common.view": "View",
    "common.remove": "Remove",
    "common.gmina": "Gmina",
    "common.powiat": "Powiat",
    "common.woj": "Voivodeship",
    "common.document": "Document",
    "common.status": "Status",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pg-lang") || "pl");
  const toggle = () => {
    const next = lang === "pl" ? "en" : "pl";
    localStorage.setItem("pg-lang", next);
    setLang(next);
  };
  const t = (key) => translations[lang][key] ?? translations.pl[key] ?? key;
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
